import { createSlice } from "@reduxjs/toolkit";
import { Biller } from "../billers/billerTypes";
import {
  startProcess,
  billerDetailsSuccess,
  billerDetailsFailure,
  fetchPlansSuccess,
  billFetchSuccess,
  billValidationSuccess,
  billPaymentSuccess,
  processFailure,
  billContextSaved,
} from "./billerDetailAction";

export interface BillerDetailState {
  step:
    | "INIT"
    | "BILLER_DETAILS"
    | "CHECK_REQUIREMENTS"
    | "PLANS_DONE"
    | "BILL_FETCH_DONE"
    | "VALIDATION_DONE"
    | "PAYMENT_DONE";
  loading: boolean;
  error?: string | null;
  biller?: Biller | null;
  planData?: any | null;
  billData?: any | null;
  validationData?: any | null;
  paymentResult?: any | null;

  billContext?: {
    refId: string;
    billerId: string;
    customerMobileNumber: string;
    customerParams: Record<string, string>;
  } | null;
}

const initialState: BillerDetailState = {
  step: "INIT",
  loading: false,
  error: null,
  biller: null,
  planData: null,
  billData: null,
  validationData: null,
  paymentResult: null,
  billContext: null,
};

const billerDetailSlice = createSlice({
  name: "billerDetails",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(startProcess, (state) => {
        state.loading = true;
        state.step = "BILLER_DETAILS";
        state.error = null;
        state.biller = null;
        state.planData = null;
        state.billData = null;
        state.validationData = null;
        state.paymentResult = null;
      })
      .addCase(billerDetailsSuccess, (state, action) => {
        state.biller = action.payload;
        state.step = "CHECK_REQUIREMENTS";
        state.loading = false;
      })
      .addCase(billerDetailsFailure, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      .addCase(fetchPlansSuccess, (state, action) => {
        state.planData = action.payload;
        state.step = "PLANS_DONE";
        state.loading = false;
      })
      .addCase(billFetchSuccess, (state, action) => {
        state.billData = action.payload;
        state.step = "BILL_FETCH_DONE";
        state.loading = false;
      })
      .addCase(billValidationSuccess, (state, action) => {
        state.validationData = action.payload;
        state.step = "VALIDATION_DONE";
        state.loading = false;
      })
      .addCase(billPaymentSuccess, (state, action) => {
        state.paymentResult = action.payload;
        state.step = "PAYMENT_DONE";
        state.loading = false;
      })
      .addCase(processFailure, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      .addCase(billContextSaved, (state, action) => {
        state.billContext = action.payload;
      });
  },
});

export default billerDetailSlice.reducer;

// import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// interface BillerDetailState {
//   step: string;
//   loading: boolean;
//   error?: string | null;
//   biller?: any | null;
//   planData?: any | null;
//   billData?: any | null;
//   validationData?: any | null;
//   paymentResult?: any | null;
// }

// const initialState: BillerDetailState = {
//   step: "INIT",
//   loading: false,
//   error: null,
//   biller: null,
//   planData: null,
//   billData: null,
//   validationData: null,
//   paymentResult: null,
// };

// const billerDetailSlice = createSlice({
//   name: "billerDetails",
//   initialState,
//   reducers: {
//     startProcess(state, action: PayloadAction<{ billerId: string; values: any }>) {
//       state.loading = true;
//       state.step = "BILLER_DETAILS";
//       state.error = null;
//       state.biller = null;
//     },
//     billerDetailsSuccess(state, action: PayloadAction<any>) {
//       state.biller = action.payload;
//       state.step = "CHECK_REQUIREMENTS";
//       state.loading = false;
//     },
//     billerDetailsFailure(state, action: PayloadAction<string>) {
//       state.error = action.payload;
//       state.loading = false;
//     },

//     fetchPlansSuccess(state, action: PayloadAction<any>) {
//       state.planData = action.payload;
//       state.step = "PLANS_DONE";
//       state.loading = false;
//     },
//     billFetchSuccess(state, action: PayloadAction<any>) {
//       state.billData = action.payload;
//       state.step = "BILL_FETCH_DONE";
//       state.loading = false;
//     },
//     billValidationSuccess(state, action: PayloadAction<any>) {
//       state.validationData = action.payload;
//       state.step = "VALIDATION_DONE";
//       state.loading = false;
//     },
//     billPaymentSuccess(state, action: PayloadAction<any>) {
//       state.paymentResult = action.payload;
//       state.step = "PAYMENT_DONE";
//       state.loading = false;
//     },

//     processFailure(state, action: PayloadAction<string>) {
//       state.error = action.payload;
//       state.loading = false;
//     },
//   },
// });

// export const {
//   startProcess,
//   billerDetailsSuccess,
//   billerDetailsFailure,
//   fetchPlansSuccess,
//   billFetchSuccess,
//   billValidationSuccess,
//   billPaymentSuccess,
//   processFailure,
// } = billerDetailSlice.actions;

// export default billerDetailSlice.reducer;
